export default __webpack_public_path__ + "static/media/4 TIEMPO.7acf7291.png";